'use client'

import { useMounted } from '@/hooks/use-mounted'
import { cn } from '@/lib/utils'
import { useTheme } from 'next-themes'
import LogoYellow from '../../public/assets/images/Logo-yellow.svg'
import LogoBlack from '../../public/assets/images/logo.svg'

interface LogoProps {
  className?: string
}

export function Logo({ className }: LogoProps) {
  const { resolvedTheme } = useTheme()
  const isMounted = useMounted()

  const isDark = resolvedTheme === 'dark'
  const logoSrc = isDark ? LogoYellow.src : LogoBlack.src

  if (!isMounted) {
    return (
      <img
        src={LogoYellow.src}
        alt="UNX"
        className={cn('opacity-0', className)}
      />
    )
  }

  const classes = cn('animate-in fade-in duration-400', className)

  return <img src={logoSrc} alt="UNX" className={classes} />
}
